import React from 'react';
import ReactDOM from 'react-dom';
import { KatSpinner } from '@amzn/katal-react';
import { Amplify } from '@aws-amplify/core';

import App from './components/App';
import AppInitWrapper from './components/AppInitWrapper';
import { amplifyAuthConfig, isValidConfig } from './config/cognitoConfig';

import '@amzn/katal-components/styles.css';
import './index.scss';

// Configure Amplify at application startup
if (amplifyAuthConfig && isValidConfig) {
    Amplify.configure({
        Auth: amplifyAuthConfig
    });
}

ReactDOM.render(
    <React.StrictMode>
        <AppInitWrapper>
            <React.Suspense fallback={<KatSpinner size="large" />}>
                <App />
            </React.Suspense>
        </AppInitWrapper>
    </React.StrictMode>,
    document.getElementById('root')
);
